module.exports = __webpack_public_path__ + "static/media/ic_caiji_green.7f35c211.svg";